import { render, staticRenderFns } from "./AiFeatureLayout.vue?vue&type=template&id=4cbeaacc&scoped=true&"
import script from "./AiFeatureLayout.vue?vue&type=script&lang=js&"
export * from "./AiFeatureLayout.vue?vue&type=script&lang=js&"
import style0 from "./AiFeatureLayout.vue?vue&type=style&index=0&id=4cbeaacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbeaacc",
  null
  
)

export default component.exports